var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-area__heading"},[_c('vx-table',{attrs:{"data":_vm.data,"columns":_vm.columns,"loading":_vm.loading},on:{"sort":function($event){return _vm.onSort(this.form[0].id_pessoa)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }